import { modalOpen } from '../../../shared/actions/authentication/modalOpen';

import type { EAlertType } from '../../../shared/types/authentication';
import type { TReduxStore } from '../../../shared/types/redux';
import type { IAPIParameters } from '@cian/mf-registry-legacy/browser';

export interface IOpenAuthModalParameters extends IAPIParameters {
  autoRefresh?: boolean;
  alert?: EAlertType | null;
  useDefaultView?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  viewData?: { headingType?: string } | null;
  source?: string | null;
}

export function openAuthModalHandler(
  store: TReduxStore,
  {
    autoRefresh = true,
    alert = null,
    useDefaultView = false,
    viewData = null,
    source = null,
  }: IOpenAuthModalParameters = {},
) {
  store.dispatch(modalOpen({ autoRefresh, alert, useDefaultView, viewData, source }));
}
